export const CompanyCodeDroOpts = () => {

    const getAllCompanyModel = (companies: any[]) => {
        const newCompanies = companies?.filter((company) => {
            return (company.companyType === 'ALLIANCE' || (company.companyType !== 'ALLIANCE' && company.status === 'CONFIRMED'))
                        && company.activeInd === 'Y';
        });

        return [
            ...(newCompanies?.map(company => ({
                dropdownLabel: company.companyCode,
                tagLabel: company.companyCode,
                value: company.companyCode
            })) ?? [])];
    }

    const getMasterCompanyModel = (companies: any[]) => {
        const newCompanies = companies?.filter((company) => {
            return (company.companyType === 'MASTER' && company.status === 'CONFIRMED' && company.activeInd === 'Y');
        });

        return [
            ...(newCompanies?.map(company => ({
                dropdownLabel: company.companyCode,
                tagLabel: company.companyCode,
                value: company.companyCode
            })) ?? [])];
    }

    const getNonMasterAllianceModel = (companies: any[]) => {
        const newCompanies = companies?.filter((company) => {
            return (
                (company.companyType !== 'ALLIANCE' || company.companyType !== 'MASTER') && company.status === 'CONFIRMED' && company.activeInd === 'Y');
        });

        return [
            ...(newCompanies?.map(company => ({
                dropdownLabel: company.companyCode,
                tagLabel: company.companyCode,
                value: company.companyCode
            })) ?? [])];
    }

    const getCcCompanyModel = (companies: any[]) => {
        const newCompanies = companies?.filter((company) => {
            return (
                (company.companyType === 'ALLIANCE' || (company.companyType !== 'ALLIANCE' && company.status === 'CONFIRMED'))
                    && company.customerType !== 'SL' && company.activeInd === 'Y');
        });

        return [
            ...(newCompanies?.map(company => ({
                dropdownLabel: company.companyCode,
                tagLabel: company.companyCode,
                value: company.companyCode
            })) ?? [])];
    }

    const getSlCompanyModel = (companies: any[]) => {
        const newCompanies = companies?.filter((company) => {
            return (
                (company.companyType === 'ALLIANCE' || (company.companyType !== 'ALLIANCE' && company.status === 'CONFIRMED'))
                    && company.customerType === 'SL' && company.activeInd === 'Y');
        });

        return [
            ...(newCompanies?.map(company => ({
                dropdownLabel: company.companyCode,
                tagLabel: company.companyCode,
                value: company.companyCode
            })) ?? [])];
    }

    return {
        getAllCompanyModel,
        getMasterCompanyModel,
        getNonMasterAllianceModel,
        getCcCompanyModel,
        getSlCompanyModel
    }
}